import React, { useMemo } from "react";

import { BarAndPieChart, BarAndPieChartData } from "../../../Components/Charts/BarAndPieChart/BarAndPieChart";

export interface RawData {
  [key: string]: any;
}

export const processTable = (rawData: RawData[]): BarAndPieChartData[] => {
  if (rawData.length === 0) {
    return [];
  }

  const columnNames = Object.keys(rawData[0]).slice(10);
  const aggregatedData: { [key: string]: number } = {};

  rawData.forEach((item) => {
    columnNames.forEach((field) => {
      if (item[field]) {
        if (!aggregatedData[field]) {
          aggregatedData[field] = 0;
        }
        aggregatedData[field]++;
      }
    });
  });

  return Object.keys(aggregatedData).map((key) => ({
    title: key.replace("Start", "").trim(),
    value: aggregatedData[key],
  }));
};

export interface ChartProps {
  data: RawData[];
}

export const CallToActionChart: React.FC<ChartProps> = ({ data }) => {
  const transformedData = useMemo(() => processTable(data), [data]);

  return (
    <>
      <BarAndPieChart data={transformedData} showTotals={true} height={400} width={600} />
      <pre>{JSON.stringify(transformedData, null, 2)}</pre>
    </>
  );
};
